module.exports = __webpack_public_path__ + "media/images/navbar/toggler-icon-cddad9f2c9f164340ed610d3cb0b7a52.svg";